var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{domProps:{"value":_vm.value},on:{"change":_vm.update}},[_c('option',{domProps:{"value":null}},[_vm._v("指定なし")]),_c('option',{attrs:{"value":"医薬品"}},[_vm._v("医薬品")]),_c('option',{attrs:{"value":"その他品"}},[_vm._v("その他品")])])}
var staticRenderFns = []

export { render, staticRenderFns }